import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_contactUs.css'

import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';

import { TextBock, TextHeader } from '../../../Controls/Digital/TextHeaders';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faSquareInstagram } from '@fortawesome/free-brands-svg-icons';

import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text, icon }) => <div> <div class="google-maps-marker"> </div> <span className="google-maps-marker-text">{text}</span></div>;

const ContactUs = (props) => {

    useEffect(() => {
    });

    const defaultProps = {
        center: {
            lat: -34.41612574283569,
            lng: 150.88449539804378
        },
        zoom: 18
    };

    return (
        <Block name="contactUs2" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Contact Us
                </Fragment>
            } />

            <TextBock text={
                <Fragment>
                    <p className="contactUs-header-header">
                        We are located at
                    </p>
                    <p className="contactUs-header-subtext">
                        168 Gipps Rd<br />
                        Gwynneville NSW 2500
                    </p>
                </Fragment>
            } />

            <Row>

                <Col lg={{ size: 11, offset:1 }}>

                    <div class="map-wrapper" style={{ height: '50vh', width: '100%' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyC0lxhbs8od46o2NjWQCcXVSWq5C_0yXJI" }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}
                            yesIWantToUseGoogleMapApiInternals
                        >
                            <AnyReactComponent
                                lat={-34.41612574283569}
                                lng={150.88449539804378}
                                text="The Bakery"
                            />

                        </GoogleMapReact>
                    </div>
                </Col>

            </Row>

            <Row className="ContactBlocks">

                <ContactBlock
                    header={
                        <Fragment>
                            Openning Hours
                        </Fragment>
                    }
                    text={
                        <Fragment>
                            Mon - Fri: 06:30am - 15:30pm<br />
                            Sat : 06:30am - 14:00pm <br />
                            Sun : (coming soon)
                        </Fragment>
                    }
                />

                <ContactBlock
                    header={
                        <Fragment>
                            Contact
                        </Fragment>
                    }
                    text={
                        <Fragment>
                            <a className="contact-email" href="mailto:gwynneville.bakery@gmail.com">gwynneville.bakery@gmail.com</a><br />
                            02 4227 2652
                        </Fragment>
                    }
                />

                <ContactBlock
                    header={
                        <Fragment>
                            Follow
                        </Fragment>
                    }
                    text={
                        <Fragment>
                            <a href="https://www.facebook.com/GwynnevilleBakery/" target="_blank"><FontAwesomeIcon icon={faFacebook} size="3x" className="contactus-media-left" /></a>&nbsp;
                            <a href="https://www.instagram.com/gwynnevillebakery/" target="_blank"><FontAwesomeIcon icon={faSquareInstagram} size="3x" className="contactus-media-right" /></a>
                        </Fragment>
                    }
                />
            </Row>

        </Block>
    );
}
export default ContactUs;


export const ContactBlock = (props) => {

    useEffect(() => {
    }, []);

    return (
        <Col lg="4" className="contact-block">
            <TextBock text={
                <Fragment>
                    <p className="contact-block-p-header text-title-text">
                        {props.header}
                    </p>
                    <p className="contact-block-p-text">
                        {props.text}
                    </p>
                </Fragment>
            } />
        </Col>
    );
};
